import { defaultBizState, useBizStore } from '@/store/use-biz-store';
import { useCustom } from './use-custom';

export function useBizState() {
  const state = useBizStore();
  const { authType, email, phone, areaCode } = state;
  const { isPasskeyEnabled } = useCustom();
  const userName = authType === 'email' ? email : phone;

  return {
    ...state,
    userName: state.userName || userName,
    areaCode: authType === 'phone' ? areaCode : defaultBizState.areaCode,
    supportPassKey: !!window.PublicKeyCredential && isPasskeyEnabled,
  };
}
